// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"fp-z","slideIn":"gp-z"};